<template>
  <div class="event-search event-sidebar-section">
    <h3 class="event-sidebar-section__title">Search Calendar</h3>

    <form
      @submit="doSearch($event)"
    >
      <div class="input-group">
        <input
          type="text"
          name="q"
          placeholder="Search by Keyword"
          :value="searchTerm"
          aria-label="Search Calendar"
        >
        <button type="submit" aria-label="Search" v-html="assets.search"></button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Search',

  computed: {
    ...mapState([
      'assets',
      'searchTerm'
    ])
  },

  methods: {
    ...mapMutations([
      'setSearch'
    ]),

    doSearch (e) {
      e.preventDefault()

      const searchTerm = e.target.querySelector('input').value

      this.setSearch(searchTerm)
    }
  }
}
</script>
